import React, { useCallback } from 'react';
import Card from 'components/inputs/Card';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { UPDATE_FIRMWARE } from 'actions/chargerOcpp';
import * as _ from 'lodash';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { GET_STATION_CHARGER_OPERATIONS, MANAGE_STATION_CHARGER_OPERATIONS } from 'components/common/constant';

const UpdateFirmwareForm = () => {
  const { chargerId } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);

  const UpdateFirmwareSchema = Yup.object().shape({
    location: Yup.string()
      .required(t('updateFirmwareForm.location'))
      .trim(t('updateFirmwareForm.space'))
      .strict(true)
      .max(255, t('updateFirmwareForm.maxlimit')),
    retries: Yup.number().required(t('updateFirmwareForm.retries')),
    retryInterval: Yup.number().required(t('updateFirmwareForm.retryInterval')),
    retrieveDate: Yup.string().required(t('updateFirmwareForm.retrieveDate')),
    retrieveTime: Yup.string().required(t('updateFirmwareForm.retrieveTime')),
  });

  const initialValues = {
    location: '',
    retries: '',
    retryInterval: '',
    retrieveDate: '',
    retrieveTime: '',
  };

  const getUpdateFirmware = useCallback((data, resetForm) => {
    dispatch({
      type: UPDATE_FIRMWARE.REQUEST,
      payload: { data },
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            toast.success('Firmware update successfully');
            resetForm();
          }
        }
      },
    });
  }, []);

  const getStationChargerOperations =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_STATION_CHARGER_OPERATIONS),
      (data) => data.name
    );

  const manageStationChargerOperations =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_STATION_CHARGER_OPERATIONS),
      (data) => data.name
    );

  return (
    <React.Fragment>
      <div className="serverOperation-title-name">{t('updateFirmwareForm.formTitle')}</div>
      <div className="serverOperation-content-wrapper">
        <Card className="serverOperation-form-main">
          <div className="serverOperation-form__block">
            <Formik
              initialValues={initialValues}
              validationSchema={UpdateFirmwareSchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                const retrieveDateMomentObj = moment(values.retrieveDate + values.retrieveTime, 'YYYY-MM-DDLT');
                const retrieveDate = retrieveDateMomentObj.utc();
                const formData = { ...values, id: chargerId, retrieveDate: retrieveDate };
                const updateFirmwareFormData = _.omit(formData, ['retrieveTime']);
                getUpdateFirmware(updateFirmwareFormData, resetForm);
                setSubmitting(false);
              }}
            >
              {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="serverOperation-form__inner">
                    <Row>
                      <Col md={12}>
                        <TextInput
                          isRequired
                          placeholder={t('updateFirmwareForm.locationLabel')}
                          label={t('updateFirmwareForm.locationLabel')}
                          value={values.location}
                          name="location"
                          onChange={handleChange}
                          error={errors.location && touched.location ? errors.location : null}
                        />
                      </Col>
                      <Col md={6}>
                        <TextInput
                          label={t('updateFirmwareForm.retryIntervalLabel')}
                          placeholder={t('updateFirmwareForm.retryIntervalLabel')}
                          type="number"
                          value={values.retryInterval}
                          name="retryInterval"
                          onChange={handleChange}
                          error={errors.retryInterval && touched.retryInterval ? errors.retryInterval : null}
                        />
                      </Col>
                      <Col md={6}>
                        <TextInput
                          label={t('updateFirmwareForm.retriesLabel')}
                          placeholder={t('updateFirmwareForm.retriesLabel')}
                          type="number"
                          value={values.retries}
                          name="retries"
                          onChange={handleChange}
                          error={errors.retries && touched.retries ? errors.retries : null}
                        />
                      </Col>
                      <Col md={6}>
                        <TextInput
                          isRequired
                          label={t('updateFirmwareForm.retrieveDateLabel')}
                          placeholder={t('updateFirmwareForm.retrieveDateLabel')}
                          type="date"
                          value={values.retrieveDate}
                          name="retrieveDate"
                          onChange={handleChange}
                          error={errors.retrieveDate && touched.retrieveDate ? errors.retrieveDate : null}
                        />
                      </Col>
                      <Col md={6}>
                        <TextInput
                          isRequired
                          label={t('updateFirmwareForm.retrieveTimeLabel')}
                          type="time"
                          value={values.retrieveTime}
                          name="retrieveTime"
                          onChange={handleChange}
                          error={errors.retrieveTime && touched.retrieveTime ? errors.retrieveTime : null}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="serverOperation-save--btn--block">
                    {!_.isEmpty(manageStationChargerOperations) ||
                    (!_.isEmpty(getStationChargerOperations) && !_.isEmpty(manageStationChargerOperations)) ? (
                      <Button type="submit" className="serverOperation-save-btn save--btn" disabled={isSubmitting}>
                        {t('updateFirmwareForm.button')}
                      </Button>
                    ) : (
                      <Button className="serverOperation-save-btn save--btn">{t('updateFirmwareForm.button')}</Button>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
export default UpdateFirmwareForm;
